/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useRef, useState } from 'react'
import noUiSlider from 'nouislider'
import { useLayout } from '../../core'
import { KTIcon } from '../../../helpers'
import { DefaultTitle } from './page-title/DefaultTitle'
import { ThemeModeSwitcher } from '../../../partials'
import moment from 'jalali-moment'
import { useMenuCountStore } from '../../../../app/core/state-management/states/menuCount'
import { Grid, Typography } from '@mui/material'
import { NotificationsModal } from '../../../partials/modals/notifications/NotificationsModal'
import { Button, ButtonGroup, Modal, ToggleButton } from 'react-bootstrap'
//
import { useAuth } from '../../../../app/modules/auth'
import { isValidRole, isValidRoleForInquiry, RoleNameEnum } from '../../../../app/core/utils/util'
import { apiCaller } from '../../../../app/core/hooks/useApi'
import { ServiceAgent } from '../../../../app/core/services/serviceAgent'
import { useLoadingContext } from '../../../../app/core/context/loading/loading'
import {
  IInquiryResponseModel,
  IFacilityInquiryRealLegalResponseModel,
} from '../../../../app/core/interfaces'
import usePDFExport from '../../../../app/core/hooks/usePDF'
import PdfExport from '../../../../app/pages/pdfexport/PdfExport'
import { useUserDetailStore } from '../../../../app/core/state-management/states/user'
// import {fakeChequeItems, fakeFacilityItems} from './fakeData'
import { useRequestStore } from '../../../../app/core/state-management/states/request'
import InquiryPdfExport from './pdf-export/InquiryPdfExport'
import FacilityPdfExport from './pdf-export/FacilityPdfExport'
import HeaderFacilityItem from './HeaderFacilityItem/HeaderFacilityItem'
import HeaderChequeItem from './HeaderChequeItem/HeaderChequeItem'

const HeaderToolbar = () => {
  const { userInfo } = useAuth()
  const isValid = isValidRoleForInquiry(userInfo?.userRoles || [])
  const [inquiryModal, setInquiryModalOpen] = useState<boolean>(false)
  const [nationalCode, setNationalCode] = useState<string>()
  //استعلام چک برگشتی حقیقی
  const [genuineBouncedChekInquiry, setGenuineBouncedChekInquiry] = useState<boolean>(true)
  //استعلام چک برگشتی حقوقی‌
  const [legalBouncedCheckInquiry, setLegalBouncedCheckInquiry] = useState<boolean>(false)
  // -- Inquiry Response Model
  const [inquiryResponseData, setInquiryResponseData] = useState<IInquiryResponseModel>()
  //استعلام تسهیلات (حقیقی/حقوقی)
  const [facilityInquiryRealLegal, setFacilityInquiryRealLegal] = useState<boolean>(false)
  const [facilityInquiryRealLegalData, setFacilityInquiryRealLegalData] =
    useState<IFacilityInquiryRealLegalResponseModel>()
  //
  const [inputDisable, setInputDisable] = useState<boolean>(false)
  // ------
  const { classes } = useLayout()
  const { state } = useMenuCountStore()
  const [show, setShow] = useState(false)
  const { handleClose, handleOpen, showLoading } = useLoadingContext()
  const { state: UserDetailState } = useUserDetailStore()
  const { state: requestStoreState } = useRequestStore()

  const { backCheques, listOfFacilities } = requestStoreState
  const { userDetail, listBoardOfDirector, userProfile, listBoardOfDirectorFacilities } = UserDetailState

  const pdfExportRef = useRef<HTMLDivElement>(null)
  const { downloader: downloadPdfExport, loading: pdfExportLoading } = usePDFExport({
    ref: pdfExportRef,
    name: `خروجی استعلام ${genuineBouncedChekInquiry
      ? 'چک برگشتی حقیقی'
      : legalBouncedCheckInquiry
        ? 'چک برگشتی حقوقی‌'
        : 'تسهیلات'
      }`,
  })
  const handleDownloadPdfExport = async () => {
    await new Promise((res) => setTimeout(res, 300))
    downloadPdfExport()
  }

  const { menuCountInfo } = state
  useEffect(() => {
    const rangeSlider = document.querySelector('#kt_toolbar_slider')
    const rangeSliderValueElement = document.querySelector('#kt_toolbar_slider_value')

    if (!rangeSlider || !rangeSliderValueElement) {
      return
    }

    // @ts-ignore
    noUiSlider.create(rangeSlider, {
      start: [5],
      connect: [true, false],
      step: 1,
      format: {
        to: function (value) {
          const val = +value
          return Math.round(val).toString()
        },
        from: function (value) {
          return value
        },
      },
      range: {
        min: [1],
        max: [10],
      },
    })

    // @ts-ignore
    rangeSlider.noUiSlider.on('update', function (values, handle) {
      rangeSliderValueElement.innerHTML = values[handle]
    })

    const handle = rangeSlider.querySelector('.noUi-handle')
    if (handle) {
      handle.setAttribute('tabindex', '0')
    }

    // @ts-ignore
    handle.addEventListener('click', function () {
      // @ts-ignore
      this.focus()
    })

    // @ts-ignore
    handle.addEventListener('keydown', function (event) {
      // @ts-ignore
      const value = Number(rangeSlider.noUiSlider.get())
      // @ts-ignore
      switch (event.which) {
        case 37:
          // @ts-ignore
          rangeSlider.noUiSlider.set(value - 1)
          break
        case 39:
          // @ts-ignore
          rangeSlider.noUiSlider.set(value + 1)
          break
      }
    })
    return () => {
      // @ts-ignore
      rangeSlider.noUiSlider.destroy()
    }
  }, [])
  const newDate = moment(new Date()).locale('fa').format('dddd jDD jMMMM jYYYY')

  const openInquiryModal = () => {
    setInquiryModalOpen(true)
  }

  const onInquiryModalClose = () => {
    setInquiryModalOpen(false)
    setInquiryResponseData(undefined)
    setFacilityInquiryRealLegalData(undefined)
    setNationalCode(undefined)
    setGenuineBouncedChekInquiry(false)
    setLegalBouncedCheckInquiry(false)
    setFacilityInquiryRealLegal(false)
  }

  const resetInquiry = () => {
    setInquiryResponseData(undefined)
    setNationalCode('')
    setFacilityInquiryRealLegalData(undefined)
  }

  const changeInquiryNationalCodeHandler = (e: any) => {
    setNationalCode(e.target?.value)
  }

  const handleSubmitInquiry = async () => {
    setInquiryResponseData(undefined)
    setFacilityInquiryRealLegalData(undefined)
    apiCaller({
      api: legalBouncedCheckInquiry
        ? ServiceAgent.user.request_getlegalbackcheques
        : genuineBouncedChekInquiry
          ? ServiceAgent.user.request_getnaturalbackcheques
          : ServiceAgent.user.request_getuserfacilityinquiry,
      apiArguments: nationalCode,
      onSuccess: (resp) => {
        if (resp.status === 200 && resp?.data?.statusCode === 200) {
          if (legalBouncedCheckInquiry || genuineBouncedChekInquiry)
            setInquiryResponseData(resp?.data?.data)
          if (facilityInquiryRealLegal) setFacilityInquiryRealLegalData(resp?.data?.data)
        }
      },
      toastMessage: true,
      onStart: handleOpen,
      onEnd: handleClose,
      onSuccessMessage: 'عملیات با موفقیت انجام شد',
    })
  }

  useEffect(() => {
    if (!genuineBouncedChekInquiry && !legalBouncedCheckInquiry && !facilityInquiryRealLegal)
      setInputDisable(true)
    else
      setInputDisable(false)
  }, [genuineBouncedChekInquiry, legalBouncedCheckInquiry, facilityInquiryRealLegal])


  return (
    <div className='toolbar d-flex align-items-stretch'>
      {/* begin::Toolbar container */}
      <div
        className={`${classes.headerContainer.join(
          ' '
        )} py-6 py-lg-0 d-flex flex-column flex-lg-row align-items-lg-stretch justify-content-lg-between`}
      >
        <DefaultTitle />
        <div className='d-flex align-items-stretch overflow-auto pt-3 pt-lg-0'>
          {/* begin::Action wrapper */}
          <div className='d-flex align-items-center'>
            {/* begin::Label */}
            {/* <span className='fs-7 text-gray-700 fw-bolder pe-3 d-none d-xxl-block'>
              Quick Tools:
            </span> */}
            {/* end::Label */}

            {/* begin::Actions */}
            <div className='d-flex'>
              {/* begin::Action */}

              {isValid && (
                <div className='d-flex align-items-center me-4'>
                  <button
                    className='btn btn-icon btn-light-primary me-1'
                    style={{ width: '100px' }}
                    type='button'
                    data-bs-toggle='tooltip'
                    title='Inquiry'
                    onClick={openInquiryModal}
                  >
                    <span className='fs-6'>استعلام</span>
                    <i className='bi bi-person-fill-exclamation fs-3 ms-2'></i>
                  </button>
                </div>
              )}
              {/* end::Action */}
              <div className='d-flex align-items-center '>
                <span className='me-1'>{newDate}</span>

                {/* begin::Theme mode */}
                {/* <div className='d-flex align-items-center'>
                  <ThemeModeSwitcher toggleBtnClass='btn btn-sm btn-icon btn-icon-muted btn-active-icon-primary' />
                </div> */}
              </div>
              <a
                className='btn btn-sm btn-icon btn-icon-muted btn-active-icon-primary position-relative'
                data-bs-toggle='modal'
                onClick={() => setShow(true)}
              >
                <Grid
                  display={'flex'}
                  alignItems={'center'}
                  justifyContent={'center'}
                  sx={{
                    backgroundColor: '#F1416C',
                    height: '20px',
                    width: '20px',
                    borderRadius: '50%',
                    position: 'absolute',
                    top: '-5px',
                    right: '15px',
                  }}
                >
                  {
                    <Typography variant='caption' sx={{ color: '#fff', fontSize: '8px', mt: '2px' }}>
                      {menuCountInfo?.allNotification}
                    </Typography>
                  }
                </Grid>
                <KTIcon iconName='notification' className='fs-1' />
              </a>
              {/* end::Theme mode */}
            </div>
            {/* end::Actions */}
          </div>
          {/* end::Action wrapper */}
        </div>
        {/* end::Toolbar container */}
      </div>
      <NotificationsModal open={show} onClose={() => setShow(false)} />
      {/* <!-- Modal --> */}
      <Modal
        show={inquiryModal}
        onHide={onInquiryModalClose}
        centered
        size={'md' as any}
        backdropClassName='custom-backdrop'
        dialogClassName='custom-dialog'
      >
        <div className='modal-content' style={{ zIndex: 200000 }}>
          <div
            className='modal-header pb-0 border-0 justify-content-between'
            style={{ position: 'relative' }}
          >
            <span className='fs-5'>استعلام</span>
            <button
              className='me-1 cursor-pointer justify-content-center align-items-center'
              style={{ border: 'none', outline: 'none', backgroundColor: 'transparent' }}
              type='button'
              data-bs-toggle='tooltip'
              title='close-inquiry'
              onClick={onInquiryModalClose}
            >
              <i
                className='bi bi-x-circle'
                style={{ fontSize: '18px', color: '#ff0000', fontWeight: 700 }}
              ></i>
            </button>
          </div>

          <div className='modal-body'>
            {/* Radio Buttons */}
            <ButtonGroup className='mb-2 d-flex flex-column gap-3'>
              {/* استعلام چک برگشتی حقیقی */}
              <div className='form-check form-switch'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  id='flexSwitchCheckChecked'
                  checked={genuineBouncedChekInquiry}
                  onChange={() => {
                    setGenuineBouncedChekInquiry((prev) => !prev)
                    setLegalBouncedCheckInquiry(false)
                    setFacilityInquiryRealLegal(false)
                  }}
                />
                <label className='form-check-label text-black' htmlFor='flexSwitchCheckChecked'>
                  استعلام چک برگشتی حقیقی
                </label>
              </div>
              {/* استعلام چک برگشتی حقوقی‌ */}
              <div className='form-check form-switch'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  id='flexSwitchCheckChecked'
                  checked={legalBouncedCheckInquiry}
                  onChange={() => {
                    setLegalBouncedCheckInquiry((prev) => !prev)
                    setFacilityInquiryRealLegal(false)
                    setGenuineBouncedChekInquiry(false)
                  }}
                />
                <label className='form-check-label text-black' htmlFor='flexSwitchCheckChecked'>
                  استعلام چک برگشتی حقوقی‌
                </label>
              </div>
              {/* استعلام تسهیلات (حقیقی/حقوقی) */}
              <div className='form-check form-switch'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  id='flexSwitchCheckChecked'
                  checked={facilityInquiryRealLegal}
                  onChange={() => {
                    setFacilityInquiryRealLegal((prev) => !prev)
                    setLegalBouncedCheckInquiry(false)
                    setGenuineBouncedChekInquiry(false)
                  }}
                />
                <label className='form-check-label text-black' htmlFor='flexSwitchCheckChecked'>
                  استعلام تسهیلات (حقیقی/حقوقی)
                </label>
              </div>
            </ButtonGroup>
            {/* NationalId */}
            <div className='form d-flex flex-column justify-content-center align-items-start'>
              <label
                className='form-check-label text-black mt-3 mb-1'
                htmlFor='inquiryNationalCode'
              >
                {genuineBouncedChekInquiry && 'کد ملی:'}
                {legalBouncedCheckInquiry && 'شناسه شرکت'}
                {facilityInquiryRealLegal && 'شناسه'}
              </label>
              <input
                id='inquiryNationalCode'
                className='form-control form-control-lg form-control-solid'
                placeholder={`${genuineBouncedChekInquiry
                  ? 'کد ملی'
                  : legalBouncedCheckInquiry
                    ? 'شناسه شرکت'
                    : 'شناسه'
                  } مدنظر را وارد کنید`}
                type='number'
                value={nationalCode}
                onChange={(e) => changeInquiryNationalCodeHandler(e)}
                disabled={inputDisable}
              />
            </div>
            {inquiryResponseData &&
              inquiryResponseData?.result.chequeList &&
              inquiryResponseData?.result.chequeList.length > 0 && (
                <div className='d-flex flex-column justify-content-start align-items-start'>
                  <span className='mt-3 mb-3 fw-bold'>لیست چک ها:</span>
                  <div
                    style={{ height: '200px', overflowY: 'scroll', width: '100%' }}
                    className='small-scrollbar'
                  >
                    {inquiryResponseData && (
                      <HeaderChequeItem chequeItems={inquiryResponseData?.result.chequeList} />
                    )}
                  </div>
                </div>
              )}
            {inquiryResponseData &&
              !facilityInquiryRealLegal &&
              (inquiryResponseData.result.chequeList == null ||
                inquiryResponseData.result.chequeList.length == 0 ||
                inquiryResponseData.result.chequeList == undefined) && (
                <div className='d-flex justify-content-start align-items-center'>
                  <i
                    className='bi bi-x-circle'
                    style={{
                      fontSize: '12px',
                      color: '#ff0000',
                      fontWeight: 700,
                      marginLeft: '3px',
                    }}
                  ></i>
                  <p className='fs-5 mt-4'>موردی یافت نشد</p>
                  <i
                    className='bi bi-x-circle'
                    style={{
                      fontSize: '12px',
                      color: '#ff0000',
                      fontWeight: 700,
                      marginRight: '3px',
                    }}
                  ></i>
                </div>
              )}
            {facilityInquiryRealLegalData &&
              facilityInquiryRealLegalData.result.facilityList &&
              facilityInquiryRealLegalData.result.facilityList.length > 0 && (
                <div className='d-flex flex-column justify-content-start align-items-start'>
                  <span className='mt-3 mb-3 fw-bold'>لیست تسهیلات:</span>
                  <div
                    style={{ height: '200px', overflowY: 'scroll', width: '100%' }}
                    className='small-scrollbar'
                  >
                    {facilityInquiryRealLegalData && (
                      <HeaderFacilityItem
                        boardOfMemberInfo={facilityInquiryRealLegalData?.result?.facilityList}
                      />
                    )}
                  </div>
                </div>
              )}
            {facilityInquiryRealLegalData &&
              !genuineBouncedChekInquiry &&
              !legalBouncedCheckInquiry &&
              (facilityInquiryRealLegalData.result.facilityList == null ||
                facilityInquiryRealLegalData.result.facilityList.length == 0 ||
                facilityInquiryRealLegalData.result.facilityList == undefined) && (
                <div className='d-flex justify-content-start align-items-center'>
                  <i
                    className='bi bi-x-circle'
                    style={{
                      fontSize: '12px',
                      color: '#ff0000',
                      fontWeight: 700,
                      marginLeft: '3px',
                    }}
                  ></i>
                  <p className='fs-5 mt-4'>موردی یافت نشد</p>
                  <i
                    className='bi bi-x-circle'
                    style={{
                      fontSize: '12px',
                      color: '#ff0000',
                      fontWeight: 700,
                      marginRight: '3px',
                    }}
                  ></i>
                </div>
              )}
          </div>
          {
            ((facilityInquiryRealLegalData && facilityInquiryRealLegalData?.result?.facilityList?.length !== 0) ||
              (inquiryResponseData && inquiryResponseData?.result.chequeList?.length !== 0)) ?
              (<>
                <button
                  className='btn btn-success btn-sm mx-6 mb-4'
                  onClick={handleDownloadPdfExport}
                  disabled={pdfExportLoading}
                  style={{ padding: '10px' }}
                >
                  {pdfExportLoading ? 'در حال دریافت...' : 'خروجی pdf'}
                  <KTIcon iconName='file-down' className='fs-1 text-white ms-1' />
                </button>
                <div className='d-flex justify-content-center align-items-center w-full px-6 pb-4'>
                  <Button
                    className='cursor-pointer justify-content-center align-items-center w-100 py-3'
                    variant='primary'
                    onClick={() => resetInquiry()}
                  >
                    <span className='fs-6'>استعلام دوباره</span>
                    <i className='bi bi-person-fill-exclamation fs-3 ms-2'></i>
                  </Button>
                </div>
              </>) :
              <div className='d-flex justify-content-center align-items-center w-full px-6 pt-2 pb-4'>
                <Button
                  disabled={inputDisable || !nationalCode}
                  className='cursor-pointer justify-content-center align-items-center w-100 py-3'
                  variant='primary'
                  onClick={() => handleSubmitInquiry()}
                >
                  <span className='fs-6'>{showLoading ? 'در حال دریافت...' : 'استعلام'}</span>
                  {!showLoading && <i className='bi bi-person-fill-exclamation fs-3 ms-2'></i>}
                </Button>
              </div>
          }
        </div>
      </Modal>
      <div
        key={userDetail?.id}
        ref={pdfExportRef}
        style={{
          position: 'fixed',
          left: '-9999px',
          top: 0,
          width: '1000px',
          zIndex: -1,
          pointerEvents: 'none',
        }}
      >
        {(genuineBouncedChekInquiry || legalBouncedCheckInquiry) && !facilityInquiryRealLegal && (
          <InquiryPdfExport
            userDetail={userDetail}
            userProfile={userProfile}
            inquiryResponseData={inquiryResponseData}
            listOfFacilities={listOfFacilities}
            listBoardOfDirector={listBoardOfDirector}
            listBoardOfDirectorFacilities={listBoardOfDirectorFacilities}
          />
        )}
        {(!genuineBouncedChekInquiry || !legalBouncedCheckInquiry) && facilityInquiryRealLegal && (
          <FacilityPdfExport
            userDetail={userDetail}
            userProfile={userProfile}
            backCheques={backCheques}
            facilityInquiryRealLegalData={facilityInquiryRealLegalData}
            listBoardOfDirector={listBoardOfDirector}
            listBoardOfDirectorFacilities={listBoardOfDirectorFacilities}
          />
        )}
      </div>
    </div>
  )
}

export { HeaderToolbar }
